<template>
<div class="hp-sustain" v-if="data.length">
    <z-caption
        class="u-bottom-margin--4-xl-important"
        size="xl"
        tag="h2"
        uppercase
        weight="900"
        :href="`/${$root.lang}/sustainability/approach-and-policy/`"
    >
        <span v-html="text.title"></span>
    </z-caption>
    <div class="row">
        <div
            class="col-default-4 col-tablet-6 col-mobile-12"
            v-for="(item, index) in data"
            :key="index"
        >
            <preview-card
                full-height
                :image="item.previewPicture.link"
                :title="item.name"
                class="hp-sustain-card"
            >
                <template #detail>
                    <div class="hp-sustain-card__content">
                        <z-caption tag="p" class="hp-sustain-card__title" size="l">
                            <span v-html="item.name"></span>
                        </z-caption>
                        <p
                            class="white-text u-bottom-margin--2-xs"
                            v-html="item.previewText"
                            v-if="item.previewText"
                        ></p>

                        <z-button
                            v-if="item.staticDetailLink && item.staticDetailLink.value"
                            tag="a"
                            :href="item.staticDetailLink.value"
                            kind="text"
                            class="white-text"
                            size="m"
                        >
                                <span v-html="text.readMore"></span>
                            <template v-slot:right>
                                <z-icon
                                    name="arrow_long"
                                    dir="right"
                                    width="40"
                                    height="24"
                                    color="#fff"
                                ></z-icon>
                            </template>
                        </z-button>

                        <div class="hp-sustain__news" v-if="item.newsLink && item.newsLink.detailPageUrl">
                            <z-caption
                                size="m"
                                class="white-text u-bottom-margin--2xs-important"
                                weight="600"
                                tag="p"
                            >
                                <span v-html="text.relatedNews"></span>
                            </z-caption>
                            <div class="hp-sustain-news">
                                <div
                                    class="hp-sustain-news__img"
                                    v-if="item.newsLink.previewPicture && item.newsLink.previewPicture.link"
                                    :style="`background-image: url(${item.newsLink.previewPicture.link});`"
                                ></div>
                                <div class="hp-sustain-news__info">
                                    <z-link
                                        theme="white"
                                        :href="item.newsLink.detailPageUrl"
                                        class="hp-sustain-news__title"
                                    >
                                        <span v-html="item.newsLink.name"></span>
                                    </z-link>
                                    <p class="hp-sustain-news__date" v-if="item.newsLink.activeFrom">
                                        {{ item.newsLink.activeFrom | momentFilter('DD MMMM YYYY') }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </preview-card>
        </div>
    </div>
</div>
</template>

<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'sustainability',
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            text: {
                title: localize({
                    ru: 'Устойчивое развитие',
                    en: 'Sustainability'
                }),
                readMore: localize({
                    ru: 'Узнать больше',
                    en: 'Read more'
                }),
                relatedNews: localize({
                    ru: 'Новость по теме:',
                    en: 'Related news:'
                })
            }
        }
    }
}
</script>

<style lang="scss">
.hp-sustain {
    &__news {
        margin-top: auto;
        padding-top: $token-spacers-3-xl;

        @include breakpoint (laptop) {
            padding-top: $token-spacers-xl;
        }

        @include breakpoint (tablet) {
            padding-top: $token-spacers-l;
        }

        @include breakpoint (v-tablet) {
            padding-top: $token-spacers-m;
        }
    }
}

.hp-sustain-card {
    line-height: 1.3;

    &__title {
        color: $token-colors-white !important;
        line-height: 1.1 !important;
        margin-bottom: $token-spacers-2-xs !important;
    }

    &__content {
        display: flex;
        flex-direction: column;
        height: 100%;
        align-items: flex-start;
    }
}

.hp-sustain-news {
    $parent: &;

    display: flex;
    align-items: flex-start;
    text-decoration: none;

    &__img {
        width: 140px;
        height: 140px;
        background-size: cover;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        flex-shrink: 0;
        margin-right: $token-spacers-2-xs;
        background-color: $token-colors-black-5;
    }

    &__title {
        @include typo-level(S);
        line-height: 1.2;
        font-weight: 500;
        margin: 0;
    }

    &__date {
        @include typo-level(XS);
        color: $token-colors-black-5;
        margin-top: $token-spacers-3-xs;
    }
}
</style>
